'use client';

import { type GetEntitlementsResponse } from '@core-api/entitlements/entitlements';
import type { Entitlements } from './types';
import { useEntitlements, useEntitlementsQuery } from './use-entitlements';

type Entitlement = keyof GetEntitlementsResponse;

export function useEntitlementQuery<E extends Entitlement>(
  entitlement: E,
): GetEntitlementsResponse[E] | null {
  const { entitlements, error, isLoading } = useEntitlementsQuery();

  if (error || isLoading || !entitlements) {
    return null;
  }

  return entitlements[entitlement];
}

export function useEntitlement<E extends Entitlement>(
  entitlementName: E,
): Entitlements[E] {
  const entitlements = useEntitlements();
  const entitlement = entitlements[entitlementName];

  // This would only happen in tests because that's the only place we allow for providing partial entitlements
  if (!entitlement) {
    throw new Error(
      `Entitlement with name "${entitlementName}" not found in context, provide a value for this entitlement in the <EntitlementsTestProvider> that wraps the rendered component`,
    );
  }

  return entitlement;
}
